import { clearPhone } from '@/services/string';
import BaseService from '@/services/base_service';

export default class VacinaService extends BaseService {
    create(model, idPet) {
        return new Promise((resolve, reject) => {
            model.id_pet = idPet;
            let vacina = _.clone(model);
            axios.post('/vacinas', vacina).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/vacinas', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/vacinas/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get('/vacinas/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    update(model) {
        return new Promise((resolve, reject) => {
            let vacina = _.clone(model);

            axios.put('/vacinas/' + vacina.id, vacina).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/vacina.js